// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".map-link[data-v-2dc28e3c]{position:relative;border-radius:.5rem;overflow:hidden}.map-link__img[data-v-2dc28e3c]{position:relative;width:100%;height:100%;-o-object-fit:cover;object-fit:cover;z-index:0}.map-link__link[data-v-2dc28e3c]{position:absolute;top:0;right:0;bottom:0;left:0;--bg-opacity:1;background-color:#484848;background-color:rgba(72,72,72,var(--bg-opacity));opacity:0;z-index:1;transition:opacity .2s ease}.map-link__link[data-v-2dc28e3c]:hover{opacity:.1}", ""]);
// Exports
module.exports = exports;
